import { Injectable } from '@angular/core';
import { NbSidebarResponsiveState, NbSidebarService, NbSidebarState, NbToggleStates } from '@nebular/theme';
import { Observable, ReplaySubject, Subject } from 'rxjs';
const SIDEBAR_STATE = 'sidebar_state';
@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private sidebarVisibility:  Subject<any> = new Subject()
  private menuVisibility = new Subject<boolean>()
  private states: { [key: string]: ReplaySubject<NbToggleStates> } = {
    "menu-sidebar": new ReplaySubject()
  }
  private statesValues: { [key: string]: NbToggleStates } = {
    "menu-sidebar": NbToggleStates.Collapsed
  } 
  // ! NOTE : should be collapse in moblie size

  constructor() { 
    this._setDefaultValue()
  }
  

  _setDefaultValue():void{
    const state: NbToggleStates = localStorage.getItem(SIDEBAR_STATE) as NbToggleStates ? localStorage.getItem(SIDEBAR_STATE) as NbToggleStates : NbToggleStates.Expanded;
    localStorage.setItem(SIDEBAR_STATE,state)
    this.states["menu-sidebar"].next(state)
    this.statesValues["menu-sidebar"] = state
    this.sidebarVisibility.next(false)
    this.menuVisibility.next(false)
  }

  toggle(tag?: string): void {
    this.statesValues[tag] = this.statesValues[tag] === NbToggleStates.Collapsed ? NbToggleStates.Expanded : NbToggleStates.Collapsed;
    this.states[tag].next(this.statesValues[tag])
    localStorage.setItem(SIDEBAR_STATE,this.statesValues[tag])
  }

  toggleVisibility():void{
    this.sidebarVisibility.next(true)
  }
  
  toggleMenuVisibility():void{
    this.menuVisibility.next(true)
  }
  // TODO: remove tag
  getSidebarState(tag?: string): ReplaySubject<NbToggleStates> {
    return this.states[tag]
  }

  getSidebarVisibility(tag?:string):Subject<boolean>{
    return this.sidebarVisibility
  }

  getMenuVisibility(tag?:string):Subject<boolean>{
    return this.menuVisibility
  }

}
